import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { VariablesGlobalesService } from '../services/variables-globales.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  variablesGlobales = inject(VariablesGlobalesService);
  private router = inject(Router);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor(){

  }

  canActivate(): boolean {

    console.log(this.router.url);
    
    if(this.variablesGlobales.loginCorrecto){
      return true
    }else{
      //this.router.navigateByUrl(this.variablesGlobales.plataforma+'login')
      this.router.navigate(['login'])
    }
    
  }
  
}
